<template>
  <div class="all_part" id="main">
    <div>
      <titleBlock_computer></titleBlock_computer>
    </div>
    <div class="input_button">
      <div class="all_input">
        <div class="all_input_top">
          <div>
            <div class="input_arr">
              <div class="input_styles">
                <div>
                  <el-input
                    v-model="newItemNo"
                    placeholder="请输入搜索条件"
                    style="width: 460px"
                  ></el-input>
                </div>
                <div class="submit_button">
                  <!-- <div class="search_button">
          <el-button type="primary" @click="TianJiaZhanShi" style="height: 48px; width: 144px"
          >报价筛选
          </el-button
          >
        </div> -->
                  <div class="search_button">
                    <div class="sousuoButton">
                      <el-button
                        type="primary"
                        @click="serchChanPin"
                        style="
                          height: 48px;
                          width: 144px;
                          margin-left: 20px;
                          font-size: 16px;
                        "
                        >搜索
                      </el-button>
                      <div class="icon_sou">
                        <img src="../assets/SouSuo.png" alt="" width="14px" />
                      </div>
                    </div>
                  </div>
                  <div class="all_second_button">
                    <div class="ChongZhi">
                      <div class="second_button" @click="clearInput">
                        <el-button
                          plain
                          type="primary"
                          style="width: 92px; height: 48px; font-size: 16px"
                          >重置
                        </el-button>
                      </div>
                      <div class="icon_chong">
                        <img src="../assets/ChongZhi.png" alt="" width="14px" />
                      </div>
                    </div>
                    <div class="second_button">
<!--                      <div class="ShouQi">-->
<!--                        <div>-->
<!--                          <el-button-->
<!--                            plain-->
<!--                            type="primary"-->
<!--                            style="width: 92px; height: 48px; font-size: 16px"-->
<!--                            @click="inputShow"-->
<!--                          >-->
<!--                            {{ PanDuanShou ? "展开" : "收起" }}-->
<!--                          </el-button>-->
<!--                        </div>-->
<!--                        <div :class="PanDuanShou ? 'icon_Shou' : 'icon_Shous'">-->
<!--                          <img src="../assets/ShouQI.png" alt="" width="14px" />-->
<!--                        </div>-->
<!--                      </div>-->
                    </div>

                    <div class="second_button" @click="clearInput">
                      <div class="Fanhu">
                        <div>
                          <el-button
                            plain
                            type="primary"
                            style="width: 92px; height: 48px"
                            @click="back_menu"
                            >返回
                          </el-button>
                        </div>
                        <div class="icon_fan">
                          <img src="../assets/FanHui.png" alt="" width="14px" />
                        </div>
                      </div>
                    </div>
<!--                    <div class="second_button">-->
<!--                      <div>-->
<!--                        <el-button-->
<!--                          @click="serchGouWuChe"-->
<!--                          plain-->
<!--                          type="primary"-->
<!--                          style="width: 122px; height: 48px; font-size: 16px"-->
<!--                          >查看清单-->
<!--                        </el-button>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="second_button">-->
<!--                      <div>-->
<!--                        <el-button-->
<!--                          @click="download"-->
<!--                          plain-->
<!--                          type="primary"-->
<!--                          style="width: 122px; height: 48px; font-size: 16px"-->
<!--                          >导出清单-->
<!--                        </el-button>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="second_button">-->
<!--                      <div>-->
<!--                        <el-button-->
<!--                          @click="clearall"-->
<!--                          plain-->
<!--                          type="primary"-->
<!--                          style="width: 122px; height: 48px; font-size: 16px"-->
<!--                          >清空清单-->
<!--                        </el-button>-->
<!--                      </div>-->
<!--                    </div>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="input_style">
              <el-input
                v-model="oldMaterialNo"
                placeholder="请输入旧料号"
                style="width: 50px"
              ></el-input>
            </div> -->
          <!-- <div>
              <el-input
                v-model="standard_code"
                placeholder="请输入标准代码"
                style="width: 50px"
              ></el-input>
            </div> -->
          <!-- <div>
            <el-input
              v-model="inquiry_no"
              placeholder="请输入询价单号"
              style="width: 50px"
            ></el-input>
          </div> -->
        </div>
      </div>
    </div>
    <div class=  "tables">
      <el-table
        :data="tableData.data"
        style="width: 100%; margin-bottom: 20px"
        height="45%"
        border
        row-key="id"
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        :tree-props="{ hasChildren: 'hasChildren', children: 'child' }"
      >
        <el-table-column type="index" width="120" label="操作" fixed>
          <template slot-scope="scope">
            <el-button
              @click="TianJiaTest"
              v-show="scope.row.child || scope.row.child == []"
              v-if="PanDuanZhuangTai == 1"
            >
              添加
            </el-button>
            <el-button
              @click="deletess"
              v-show="scope.row.child || scope.row.child == []"
              v-if="PanDuanZhuangTai == 2"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="product_number" label="平台产品编号" width="160"> -->
        <!-- </el-table-column> -->
      
        <el-table-column

          prop="quadrant"
          label="所属象限"
          width="160"
        ></el-table-column>
          <el-table-column

          prop="enterprise"
          label="竞争对手"
          width="160"
        ></el-table-column>
        <el-table-column

          prop="enterprise_name"
          label="竞争人员"
          width="120"
        ></el-table-column>
        <el-table-column

          prop="enterprise_type"
          label="竞争对手关联类型"
          width="120"
        ></el-table-column>
        <el-table-column

          prop="enterprise_end"
          label="最终用户"
          width="120"
        ></el-table-column>
        <el-table-column

          prop="enterprise_end_name"
          label="最终用户竞争人员"
          width="180"
        ></el-table-column>
        <!-- <el-table-column prop="product_category" label="产品类别" width="90">
        </el-table-column> -->
        <!-- <el-table-column
          prop="category_small"
          label="产品小类"
          width="120"
        ></el-table-column> -->
        <!-- <el-table-column
          prop="material"
          label="材质"
          width="120"
        ></el-table-column> -->

        <!-- <el-table-column
          prop="hardness"
          label="硬度"
          width="120"
        ></el-table-column> -->
        <!-- <el-table-column
          prop="color"
          label="颜色"
          width="120"
        ></el-table-column> -->
        <el-table-column

          prop="enterprise_end_type"
          label="最终用户关联类型"
          width="120"
        ></el-table-column>
        <el-table-column

          prop="equipment_supplier"
          label="OEM设备商"
          width="120"
        ></el-table-column>
        <el-table-column prop="MOQ" label="MOQ" width="120"></el-table-column>
        <el-table-column
          prop="related_personnel_supplier_name"
          label="设备竞争人员"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="equipment_supplier_type"
          label="设备关联类型"
          width="160"
        ></el-table-column>
        <el-table-column
          prop="device_type"
          label="设备型号"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="process_technology"
          label="制程工艺"
          width="160"
        ></el-table-column>
        <!-- <el-table-column
          prop="account_manager"
          label="客户经理"
          width="140"
        ></el-table-column> -->
        <!-- <el-table-column
          fixed
          prop="oldMaterialNo"
          label="旧料号"
          width="160"
        ></el-table-column>
        <el-table-column
          fixed
          prop="newItemNo"
          label="新料号"
          width="160"
        ></el-table-column> -->

        <el-table-column
          prop="category"
          label="竞品类别"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="equipment_condition"
          label="竞品&设备情况"
          width="140"
        ></el-table-column>
        <el-table-column

          prop="personnel_relations"
          label="人员关系&活动"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="add_time"
          label="添加时间"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="edit_time"
          label="修改时间"
          width="120"
        ></el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        layout="prev, pager, next"
        :total="tableData.total"
        hide-on-single-page="true"
        @current-change="reflash"
      >
      </el-pagination>
    </div>
    <div class="Copyright_information">
      <span>Copyright © 胤舜密封EBD数据平台限内部使用 版权所有</span>
    </div>
  </div>
</template>
<script>
import titleBlock_computer from "../views/titleBlock_computer.vue";
import { httpUrl } from "../components/publics";
import DevicePixelRatio from '@/views/DevicePixelRatio.js';
export default {
  data() {
    return {
      user_leave: {},
      PanDuanShou: false,
      tableData: [],
      newItemNo: "", //新料号
      oldMaterialNo: "", //旧料号
      internal_meridian: "", // 产品内径
      wire_diameter: "", //产品线径
      ChanPinXiaoLei_choice: "", //产品小类选择
      CaiZhi_choice: "", //材质选择   //material
      BiaoZhun_Choice: "", //标准选择
      YingDu_Choice: "", //硬度选择
      standard_code: "", //标准代码
      inquiry_no: "", //询价单号
      CaiLiaoXinXi_Code_Choice: "", //材料信息选择
      ChanPinDaLei_choice: "", // 产品大类选择
      YanSe_Choice: "", //颜色选择
      ChanPinDaLei_Select: [], // 产品大类下拉框
      ChanPinXiaoLei_Select: [], //产品小类下拉框
      CaiZhi_select: [], //材质选择拉下
      BiaoZhun_Select: [], //标准下拉框
      YingDu_Select: [], //硬度下拉框
      CaiLiaoXinXi_Code_Select: [], //材料信息下拉框
      YanSe_Select: [], //颜色下拉框
      page: "",
      multipleSelection: [],
      PanDuanZhuangTai: "",
      key:"",
    };
  },
  watch: {
    ChanPinDaLei_choice(newName, oldName) {
      this.serchChanPinXiaoLei(newName);
    },
    CaiZhi_choice(newName, oldName) {
      this.serchCaiLiaoXinxi(newName);
      this.serchYanSe(newName);
      this.serchBiaoZhun(newName);
    },
  },
  mounted() {
    this.serchCaiZhi();
    this.serchChanPinDaLei();
    new DevicePixelRatio().init();
    this.serchYingDu();
    this.getUser();
    this.serchChanPin();
  },

  methods: {
    getUser() {
      this.user_leave = JSON.parse(sessionStorage.getItem("user"));
      console.log(this.user_leave, "这里看的是userID");
    },
    add(val) {
      this.axios
        .post(
          httpUrl + "/api/index/offerAdd",
          this.$qs.stringify({
            data: val,
          })
        )
        .then((response) => {
          if (response.data.code === 200) {
            this.$message(response.data.message);
            console.log("success", response.data);
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    delete(val) {
      this.axios
        .get(httpUrl + `/api/index/offerStrDel?id=${val}`)
        .then((response) => {
          if (response.data.code === 200) {
            this.serchGouWuChe2();
            this.$message(response.data.message);
            console.log("success", response.data);
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    TianJiaTest() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      let stringTest = this.$refs.multipleTable.tableData;
      stringTest.forEach((element) => {
        element.user_id = selectID;
      });
      let a = {};
      stringTest.map((val) => {
        delete val.child;
        a = JSON.stringify(val);
      });
      // this.add(a);
      console.log(stringTest);
      console.log(a);
      console.log(this.$refs.multipleTable.selection);
    },
    deletess() {
      let stringTest = this.$refs.multipleTable.tableData;
      stringTest.forEach((element) => {
        // element.user_id = selectID;
      });
      let a = {};
      stringTest.map((val) => {
        delete val.child;
        a = JSON.stringify(val.id);
      });
      this.delete(a);
      console.log(stringTest);
      console.log(a);
      console.log(this.$refs.multipleTable.selection);
    },
    change(params, val) {
      console.log(params);
      if (params == "a" && val != "") {
        this.ChanPinXiaoLei_choice = "";
        this.CaiZhi_choice = "";
      }
    },
    back_menu() {
      this.$router.push("/second_menuComputer_PriceAndInventory");
    },
    clearall() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      this.axios
        .get(httpUrl + `/api/index/offerDel?user_id=${selectID}`)
        .then((response) => {
          if (response.data.code === 200) {
            this.serchGouWuChe2();
            this.$message(response.data.message);
            console.log("success", response.data);
          }
        })
        .catch((error) => console.log(error, "error"));
    },
    clearInput() {
      this.tableData = [];
      this.newItemNo = ""; //新料号
      this.oldMaterialNo = ""; //旧料号
      this.internal_meridian = ""; // 产品内径
      this.wire_diameter = ""; //产品线径
      this.ChanPinXiaoLei_choice = ""; //产品小类选择
      this.CaiZhi_choice = ""; //材质选择   //material
      this.BiaoZhun_Choice = ""; //标准选择
      this.YingDu_Choice = ""; //硬度选择
      this.standard_code = ""; //标准代码
      this.inquiry_no = ""; //询价单号
      this.CaiLiaoXinXi_Code_Choice = ""; //材料信息选择
      this.ChanPinDaLei_choice = ""; // 产品大类选择
      this.YanSe_Choice = ""; //颜色选择
      this.YanSe_Select = [];
      this.ChanPinDaLei_Select = [];
    },
    inputShow() {
      if (this.PanDuanShou) {
        this.PanDuanShou = !this.PanDuanShou;
      } else {
        this.PanDuanShou = !this.PanDuanShou;
      }
    },
    reflash(val) {
      this.page = val;
      this.serchFinanceinfo();
    },
    serchBiaoZhun(val) {
      this.axios
        .get(httpUrl + `/api/index/standard?material=${val}`)
        .then((response) => {
          if (response.data.code == 200) {
            this.BiaoZhun_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchYingDu() {
      this.axios
        .get(httpUrl + `/api/index/hardness`)
        .then((response) => {
          if (response.data.code == 200) {
            this.YingDu_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchCaiLiaoXinxi(vars) {
      this.axios
        .get(httpUrl + `/api/index/material_number?material=${vars}`)
        .then((response) => {
          if (response.data.code == 200) {
            this.CaiLiaoXinXi_Code_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchYanSe(vals) {
      this.axios
        .get(httpUrl + `/api/index/colorOffer?material=${vals}`)
        .then((response) => {
          if (response.data.code == 200) {
            this.YanSe_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchCaiZhi() {
      this.axios
        .get(
          httpUrl +
            `/api/index/standard_material?category_small=${this.ChanPinXiaoLei_choice}&`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.CaiZhi_select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchChanPinXiaoLei(val) {
      this.axios
        .get(
          httpUrl + `/api/index/standard_category?category_big=${val}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.ChanPinXiaoLei_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchChanPinDaLei() {
      this.axios
        .get(httpUrl + `/api/index/category`)
        .then((response) => {
          if (response.data.code == 200) {
            this.ChanPinDaLei_Select = response.data.data;
            console.log(this.tableData.data);
          }
          // this.$message("搜索成功");
          console.log("success", response.data);
        })
        .catch((error) => console.log(error, "error"));
    },
    serchChanPin() {
      let suser_id = JSON.parse(sessionStorage.getItem("user"));
      let selectID = suser_id.id;
      console.log(selectID);
      this.axios
        .get(
          httpUrl +
            `/api/competitive_product/competitiveProductList?key=${this.key}&user_id=${this.user_leave.id}`
        )
        .then((response) => {
          if (response.data.code == 200) {
            this.PanDuanZhuangTai = 1;
            this.tableData = response.data.data;
            console.log(this.tableData)
            if (response.data.code == 401) {
              this.$message(response.data.message);
            } else {
              // response.data.data.map((value, key) => {
              //   if (value.child.length > 0) {
              //     value.child.map((val, num) => {
              //       val["id"] = value.id * 10 + num;
              //     });
              //   }
              // });
              this.tableData = response.data.data;
            }
            // this.tableData = response.data.data
            // console.log(this.tableData.data)
            //     newItemNo:"",//新料号
            //     oldMaterialNo:"",//旧料号
            //     internal_meridian:"", // 产品内径
            //     wire_diameter:"",//产品线径
            //     ChanPinXiaoLei_choice:"",//产品小类选择
            //     CaiZhi_choice:"",//材质选择   //material
            //     BiaoZhun_Choice:"",//标准选择
            //     YingDu_Choice:"",//硬度选择
            //     standard_code:"",//标准代码
            //     inquiry_no:"",//询价单号
            //     CaiLiaoXinXi_Code_Choice:"",//材料信息选择
            //     ChanPinDaLei_choice:"", // 产品大类选择
            //     YanSe_Choice:"",//颜色选择
            //     ChanPinDaLei_Select:[],  // 产品大类下拉框
            //     ChanPinXiaoLei_Select:[],//产品小类下拉框
            //     CaiZhi_select:[], //材质选择拉下
            //     BiaoZhun_Select:[],//标准下拉框
            //     YingDu_Select:[],//硬度下拉框
            //     CaiLiaoXinXi_Code_Select:[],//材料信息下拉框
            //     YanSe_Select:[],//颜色下拉框
          }
          // this.$message("搜索成功");
          this.$message(response.data.message);
        })
        .catch((error) => console.log(error, "error"));
    },
  },
  components: {
    titleBlock_computer,
  },
};
</script>

<style>
.table-column-hidden .el-checkbox__input {
  display: none;
}

.el-input {
  border: 1px solid #b7b7b7;
  border-radius: 4px;
  color: #353535;
}
</style>
<style scoped>
.el-icon-my-SouSuo {
  background: url("../assets/SouSuo.png") no-repeat;
  font-size: 16px;
  background-size: cover;
}

.el-icon-my-SouSuo:before {
  content: "";
  font-size: 16px;
}

.all_part {
  min-height: 925px;
  min-width: 1920px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100vh;
}

.all_input {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
}

.all_input_top {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px 0;
}

.all_input_bottom {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.submit_button {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.all_second_button {
  display: flex;
  flex-direction: row;
  margin-right: 20px;
}

.second_button {
  margin-left: 20px;
}

.Copyright_information {
  margin-top: auto;
  margin-bottom: 10px;
}

.table {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
  height: 66%;
  width: 100%;
}

.tables {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
  height: 80%;
}

.input_style {
  margin-top: 5px;
  margin-bottom: 5px;
  margin-right: 10px;
}

.input_styles {
  width: 55%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.input_arr {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* border: 1px #999999 dashed; */
}

.input_arr_span {
  margin-right: 10px;
  font-size: 14px;
}

.sousuoButton {
  position: relative;
}

.icon_sou {
  top: 16px;
  left: 40px;
  position: absolute;
}

.ChongZhi {
  position: relative;
}

.icon_chong {
  top: 16px;
  left: 32px;
  position: absolute;
}

.ShouQi {
  position: relative;
}

.icon_Shou {
  top: 14px;
  left: 12px;
  transform: rotate(180deg);
  position: absolute;
}

.icon_Shous {
  top: 15px;
  left: 12px;
  position: absolute;

}

.icon_fan {
  top: 16px;
  left: 12px;
  position: absolute;
}

.Fanhu {
  position: relative;
}
</style>